import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Link from '@nubank/nuds-web/components/Link/Link';

function SectionWanted({ index }) {
  const { formatMessage } = useContext(NuDsContext);
  return (
    <Box
      tag="section"
      display="flex"
      backgroundColor="white"
      paddingVertical={{ xs: '12x', md: '20x', lg: '32x' }}
      backgroundImage={{
        xs: {
          '1x': 'mulher-com-cachos-maravilhosos-segurando-cartao/mulher-com-cachos-maravilhosos-segurando-cartao-xs@1x.jpg',
          '2x': 'mulher-com-cachos-maravilhosos-segurando-cartao/mulher-com-cachos-maravilhosos-segurando-cartao-xs@2x.jpg',
          '3x': 'mulher-com-cachos-maravilhosos-segurando-cartao/mulher-com-cachos-maravilhosos-segurando-cartao-xs@3x.jpg',
        },
        md: {
          '1x': 'mulher-com-cachos-maravilhosos-segurando-cartao/mulher-com-cachos-maravilhosos-segurando-cartao-md@1x.jpg',
          '2x': 'mulher-com-cachos-maravilhosos-segurando-cartao/mulher-com-cachos-maravilhosos-segurando-cartao-md@2x.jpg',
          '3x': 'mulher-com-cachos-maravilhosos-segurando-cartao/mulher-com-cachos-maravilhosos-segurando-cartao-md@3x.jpg',
        },
        lg: {
          '1x': 'mulher-com-cachos-maravilhosos-segurando-cartao/mulher-com-cachos-maravilhosos-segurando-cartao-lg@1x.jpg',
          '2x': 'mulher-com-cachos-maravilhosos-segurando-cartao/mulher-com-cachos-maravilhosos-segurando-cartao-lg@2x.jpg',
          '3x': 'mulher-com-cachos-maravilhosos-segurando-cartao/mulher-com-cachos-maravilhosos-segurando-cartao-lg@3x.jpg',
        },
      }}
      backgroundSize="cover"
      minHeight={{ xs: '125vw', md: '100vw', lg: 'calc(100vh - 3.5rem)' }}
    >
      <Grid
        paddingLeft={{ xs: '8x', md: '16x' }}
        paddingRight={{ xs: '8x', md: '16x' }}
        rowGap="12x"
        alignItems={{ lg: 'center' }}
      >
        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '3 / span 4', lg: '8 / span 5' }}
        >
          <Typography
            variant="title"
            color="white"
            marginBottom="4x"
            intlKey={`cms.cardPage.cardCardsArea[${index}].cardSampleCardTitle`}
          />
          {formatMessage({
            id: `cms.cardPage.cardCardsArea[${index}].cardSampleCardDescription`,
          }, {
            p: props => <Typography marginBottom="5x" color="white" variant="paragraph2" {...props} />,
            a: props => (
              <Link
                typographyProps={{
                  variant: 'paragraph2',
                }}
                {...props}
              />
            ),
          })}
        </Grid.Child>
      </Grid>
    </Box>
  );
}

SectionWanted.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionWanted);
